/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css } from '@emotion/react';
import { headingsSharedStyles, blockquoteSharedStyles } from '@atlaskit/editor-common/styles';
import { shortcutStyle } from '@atlaskit/editor-shared-styles/shortcut';
import { N400 } from '@atlaskit/theme/colors';
export var blockTypeMenuItemStyle = function blockTypeMenuItemStyle(tagName, selected, typographyTheme) {
  // TEMP FIX: See https://product-fabric.atlassian.net/browse/ED-13878
  var selectedStyle = selected ? "".concat(tagName, " { color: ", "var(--ds-text, white)", " !important; }") : '';
  return function () {
    return css(
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    tagName === 'blockquote' ? blockquoteSharedStyles : headingsSharedStyles(typographyTheme), {
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
      '>': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        'h1, h2, h3, h4, h5, h6': {
          marginTop: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        blockquote: {
          paddingTop: 0,
          paddingBottom: 0,
          marginTop: 0
        }
      }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    selectedStyle);
  };
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
export var keyboardShortcut = css(shortcutStyle, {
  marginLeft: "var(--ds-space-200, 16px)",
  color: "var(--ds-icon, ".concat(N400, ")")
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var keyboardShortcutSelect = css({
  color: "var(--ds-icon, ".concat(N400, ")")
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var wrapperSmallStyle = css({
  marginLeft: "var(--ds-space-050, 4px)",
  minWidth: '40px'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var expandIconWrapperStyle = css({
  marginLeft: "var(--ds-space-negative-100, -8px)"
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles
export var floatingToolbarWrapperStyle = css({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  "[data-role='droplistContent']": {
    maxHeight: '90vh'
  }
});